import { AppShell } from '../components/AppShell';

export function NotFoundPage() {
  return (
    <AppShell title="Not found">
      <p class="muted">The page you tried to open does not exist.</p>
    </AppShell>
  );
}
